import * as Yup from 'yup';
import { TFunction } from 'i18next';
import { getTranslationValidationHandling } from 'Hooks/query-hooks/helper';

export const tenantGroupValidationSchema = (t: TFunction, existingTenantGroupNames: string[]) => {
    const validationT = getTranslationValidationHandling(t);

    const tenantGroupName = t('Tenant Group Name');

    return Yup.object().shape({
        name: Yup.string()
            .required(validationT('required', { field: tenantGroupName }))
            .test({
                name: 'name',
                message: t('uniqueTenantGroupNameError'),
                test: (value = '') => {
                    return !existingTenantGroupNames.includes(value.toLowerCase());
                }
            }),
        description: Yup.string()
    });
};
